import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from "@angular/core";
import { UniStepperComponent } from "@universal-ui";
import { TrustRequest } from "@fiduciaria/Shared/Types/request.interface";
import { TrustRequestsFilter } from "@fiduciaria/Shared/Types/requests-filter.interface";
import { FiduciaryRepository } from "@fiduciaria/Shared/Repositories/fiduciary.repository";
import { WaitingForInformationStatusMessage } from "@fiduciaria/Shared/Types/files/request-files.interface";

@Component({
  selector: "app-request-details",
  templateUrl: "./request-details.component.html",
  styleUrls: ["./request-details.component.scss"],
})
export class RequestDetailsComponent implements OnInit {
  public estadoEsperaInformacionCliente: string = "00005";
  public estadoFinalizado: string = "00011";
  public caseData: WaitingForInformationStatusMessage;
  public caseId: number;
  public fiduciaryNote: string;
  public caseCloseNote: string;

  @ViewChild("stepper") private readonly stepper: UniStepperComponent;
  @Input() public request: TrustRequest;
  @Input() public requestFilter: TrustRequestsFilter;
  @Output() public refreshRequestResult = new EventEmitter<TrustRequestsFilter>();

  constructor(private readonly fiduciaryRepository: FiduciaryRepository) {
    this.fiduciaryNote = "Los documentos asociados a casos creados a través del buzón de Solicitudes Fiduciaria";
    this.fiduciaryNote += ", pueden ser consultados a través del correo electrónico del solicitante.";
  }

  public get caseDataComment(): string {
    return this.caseData?.observationMessage ?? "";
  }

  public get caseFinalResponseComment(): string {
    return this.caseData?.finalResponseMessage ?? "";
  }

  public get createdByFiduciary(): boolean {
    const createdBy: string = (this.request["createdBy"] ?? "").trim();
    return ["Fiduciaria", "Caso Automático"].includes(createdBy);
  }

  public get isFinished(): boolean {
    return (this.caseData?.requestStatusCode ?? "").trim() === this.estadoFinalizado;
  }

  public get isWaitingForInformation(): boolean {
    return (this.caseData?.requestStatusCode ?? "").trim() === this.estadoEsperaInformacionCliente;
  }

  public ngOnInit(): void {
    this.caseId = this.request?.processId ?? 0;
    this.getRequestDetails(this.caseId);

    this.caseCloseNote = "Para obtener más información sobre los documentos relacionados con la finalización de este caso";
    this.caseCloseNote += ` , consulte el correo electrónico correspondiente, utilizando el número de caso de referencia ${(this.request?.requestNumber ?? "")}.`;
  }

  public onKeyUpChangeStep(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public changeStep(index: number): void {
    this.stepper.to(index);
  }

  public onNext(): void {
    this.stepper.next();
  }

  public onBack(): void {
    this.stepper.previous();
  }

  public getRequestDetails(caseId: number): void {
    if (caseId <= 0) return;
    this.fiduciaryRepository.getRequestDetails(caseId).subscribe((data: WaitingForInformationStatusMessage) => {
      this.caseData = data;
    });
  }

  public getRequestResult(): void {
    this.refreshRequestResult.emit(this.requestFilter);
  }

  public formatDate(date: string): string {
    let dataReplaced: string = date.replace("T", "|")
    dataReplaced = dataReplaced.split("+")[0];
    const dateArray: string[] = dataReplaced.split("|");
    if(dateArray.length < 2) return date;

    return this.formatDateTime(dateArray[0], dateArray[1]);
 }

  public formatDateTime(date: string, time: string): string {
      const dateTimeString = `${date} ${time}`;
      const dateTime = new Date(dateTimeString);
      if (isNaN(dateTime.getTime())) throw new Error('La fecha o la hora no es válida');
      
      const formattedDate = new Intl.DateTimeFormat('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
      }).format(dateTime);

      return formattedDate;
  }
}
